var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeniorChecking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#senior_checking_svg__clip0_10292_427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.478 10.452a1.58 1.58 0 00-2.396-.742 1.209 1.209 0 01-1.398-1.973c2.146-1.52 5.15-.59 6.061 1.876l4.17 11.277a1.199 1.199 0 01.069.646 1.209 1.209 0 01-1.22 1.009h-2.19a6.306 6.306 0 01-12.497-1.209c0-.391-.105-.979-.376-1.43-.238-.396-.58-.672-1.2-.672-.622 0-.964.276-1.202.672-.27.451-.375 1.039-.375 1.43a6.306 6.306 0 01-12.497 1.209h-2.19a1.209 1.209 0 01-1.151-1.657L4.255 9.613c.912-2.466 3.915-3.396 6.061-1.876A1.209 1.209 0 018.919 9.71a1.58 1.58 0 00-2.397.742l-3.577 9.675h.482a6.308 6.308 0 0111.615-2.008c.573-.577 1.38-.987 2.458-.987 1.078 0 1.886.41 2.458.987a6.308 6.308 0 0111.616 2.008h.482l-3.578-9.675zM9.618 25.225a3.889 3.889 0 100-7.778 3.889 3.889 0 000 7.778zm15.765 0a3.889 3.889 0 100-7.778 3.889 3.889 0 000 7.778z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "senior_checking_svg__clip0_10292_427"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v35H0z"
  })))));
}

export default SvgSeniorChecking;